import { WIDGET_TYPE } from '../../../constants';
import { WidgetType } from '../../../types';

import EventsWidget from './EventsWidget';

export const widgets: WidgetType[] = [
  { id: 'EventsWidget', type: WIDGET_TYPE.NORMAL, component: EventsWidget },
];
